var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upcoming-event-report-container" }, [
    _c(
      "div",
      { staticClass: "row" },
      _vm._l(_vm.reports, function(item) {
        return _c(
          "div",
          { staticClass: "col-md-6 col-lg-4" },
          [_c("EventCompletedReportCard", { attrs: { eventInfo: item } })],
          1
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f64da83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f64da83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/reports/CompletedReport.vue
// module id = 2104
// module chunks = 1